const ContractStatus = {
  DRAFT: 'DRAFT',
  PENDING_SIGNATURE: 'PENDING_SIGNATURE',
  IN_PROGRESS: 'IN_PROGRESS',
  ENDED: 'ENDED',
  CANCELLED: 'CANCELLED',
  SIGNED: 'SIGNED',
  CEDED: 'CEDED'
};

export const ContractPaymentStatus = {
  UP_TO_DATE: 'UP_TO_DATE',
  OVERDUE: 'OVERDUE'
};

export const ContributionStatus = {
  PENDING: 'PENDING',
  COMPLETED: 'COMPLETED'
};

export const AmendingAgreementSignStatus = {
  SIGNED: 'SIGNED',
  PENDING_SIGNATURE: 'PENDING_SIGNATURE'
};

export const ContractCessionSignStatus = {
  DRAFT: 'DRAFT',
  SIGNED: 'SIGNED',
  PENDING_SIGNATURE: 'PENDING_SIGNATURE'
};

export const ContractEarlyTerminationSignStatus = {
  SIGNED: 'SIGNED',
  PENDING_SIGNATURE: 'PENDING_SIGNATURE'
};

export const AutomaticDebitRequestSignStatus = {
  DRAFT: 'DRAFT',
  PENDING_TO_SIGN: 'PENDING_TO_SIGN',
  SIGNED: 'SIGNED'
};

export const hasContractDigitalSign = contract => {
  return Boolean(contract.weetrustDocId);
};

export const hasPromissoryNoteDigitalSign = promissoryNote => {
  return Boolean(promissoryNote.weetrustDocId);
};

export const ContractDetailTabsIndex = {
  DETAIL: 'detail',
  AVALS: 'avals',
  CONTRIBUTIONS: 'contributions',
  FISCAL_BALANCE: 'fiscal-balance',
  PAYMENT_SCHEDULE: 'payment-schedule',
  ACCOUNTING_STATE: 'accounting-state',
  CONTRACT_EVENTS: 'contract-events',
  ACCOUNTING_BALANCE: 'accounting-balance'
};

export const FiscalBalanceSubTabsIndex = {
  CAPITAL: 'capital',
  INTEREST: 'interest'
};

export const ContractCreationOption = {
  CREATE_CONTRACT: 'CREATE_CONTRACT',
  CREATE_CONTRACT_TO_DIGITAL_SIGN: 'CREATE_CONTRACT_TO_DIGITAL_SIGN'
};

export const ContractActionsOptions = {
  SEND_TO_DIGITAL_SIGN: 'SEND_TO_DIGITAL_SIGN',
  SIGN_MANUALLY: 'SIGN_MANUALLY',
  RESEND_TO_SIGN: 'RESEND_TO_SIGN',
  ACTIVATE_AUTOMATIC_BILLING: 'ACTIVATE_AUTOMATIC_BILLING',
  DESACTIVATE_AUTOMATIC_BILLING: 'DESACTIVATE_AUTOMATIC_BILLING',
  EDIT_CONTRACT_DATES: 'EDIT_CONTRACT_DATES',
  GENERATE_AUTOMATIC_REQUEST_DOCUMENT: 'GENERATE_AUTOMATIC_REQUEST_DOCUMENT',
  REGENERATE_AUTOMATIC_REQUEST_DOCUMENT:
    'REGENERATE_AUTOMATIC_REQUEST_DOCUMENT',
  CANCEL_CONTRACT: 'CANCEL_CONTRACT',
  CEDE_CONTRACT: 'CEDE_CONTRACT',
  TERMINATE_CONTRACT_EARLY: 'TERMINATE_CONTRACT_EARLY',
  CANCEL_CONTRACT_CESSION: 'CANCEL_CONTRACT_CESSION',
  RESEND_SIGN_REQUEST_FOR_CONTRACT_CESSION:
    'RESEND_SIGN_REQUEST_FOR_CONTRACT_CESSION',
  SEND_CONTRACT_CESSION_TO_SIGN: 'SEND_CONTRACT_CESSION_TO_SIGN',
  SEND_TO_DRAFT: 'SEND_TO_DRAFT',
  GENERATE_TERMINATION_LETTER: 'GENERATE_TERMINATION_LETTER',
  TERMINATE_CONTRACT: 'TERMINATE_CONTRACT',
  ASSIGN_FIDEICOMISO: 'ASSIGN_FIDEICOMISO'
};

export const ContractEvents = {
  CANCELLATION: 'CANCELLATION',
  CONTRACT_ASSIGNMENT: 'CONTRACT_ASSIGNMENT',
  TERMINATION: 'TERMINATION',
  CAPITAL_CONTRIBUTION: 'CAPITAL_CONTRIBUTION',
  SIGNATURE: 'SIGNATURE',
  CREATION: 'CREATION',
  EARLY_TERMINATION: 'EARLY_TERMINATION'
};

export const getContractEventsLabels = t => [
  {
    key: ContractEvents.CANCELLATION,
    name: t('CONTRACT_EVENTS_TYPES.CANCELLATION')
  },
  {
    key: ContractEvents.CONTRACT_ASSIGNMENT,
    name: t('CONTRACT_EVENTS_TYPES.CONTRACT_ASSIGNMENT')
  },
  {
    key: ContractEvents.TERMINATION,
    name: t('CONTRACT_EVENTS_TYPES.TERMINATION')
  },
  {
    key: ContractEvents.CAPITAL_CONTRIBUTION,
    name: t('CONTRACT_EVENTS_TYPES.CAPITAL_CONTRIBUTION')
  },
  {
    key: ContractEvents.SIGNATURE,
    name: t('CONTRACT_EVENTS_TYPES.SIGNATURE')
  },
  { key: ContractEvents.CREATION, name: t('CONTRACT_EVENTS_TYPES.CREATION') },
  {
    key: ContractEvents.EARLY_TERMINATION,
    name: t('CONTRACT_EVENTS_TYPES.CONTRACT_EARLY_TERMINATION')
  }
];

export const ContractsComments = {
  CEDED: 'CEDED',
  EARLY_TERMINATED: 'EARLY_TERMINATED'
};

export const ContractsEventsStatus = {
  PENDING: 'PENDING',
  COMPLETED: 'COMPLETED',
  CANCELLED: 'CANCELLED'
};

export const TerminationLetterOpions = {
  SEND_TO_CLIENT: 'SEND_TO_CLIENT'
};

export default ContractStatus;

export const ContractPaymentForm = {
  BANK_TRANSFER: 'BANK_TRANSFER',
  CREDIT_CARD: 'CREDIT_CARD',
  AUTOMATIC_DEBIT: 'AUTOMATIC_DEBIT'
};
